import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AgGridModule } from "ag-grid-angular";
import { PaginationModule, SelectModule, IconButtonModule, SkeletonModule, ProgressModule, ColumnSwitcherModule, LibPopoverModule, DateRangeModule, RadioCheckboxModule } from "@bssh/comp-lib";
import { BsshDataTableComponent } from "./bssh-data-table.component";
import { BsshColumnSwitcherComponent } from "./column-switcher/bssh-column-switcher.component";
import { CustomPageSizeControllerModule } from "./custom-page-size-controller/custom-page-size-controller.module";
import { CustomHeaderComponent } from "./custom-header/custom-header.component";
import { SpanCellRendererComponent } from "./span/span-cell-renderer.component";
import { LinkCellRendererComponent } from "./link/link-cell-renderer.component";
import { CustomFilterComponent } from "./custom-filter/custom-filter.component";
import { BsshDataTableMessageService } from "./services/bssh-data-table-message.service";
import { BsshDataTableApiService } from "./services/bssh-data-table-api-service.service";
import { BsshDataTableServerSideDatasourceService } from "./services/bssh-data-table-server-side-datasource.service";
import { CustomLoadingOverlayComponent } from "./custom-loading-overlay/custom-loading-overlay.component";
import { CustomCellLoadingRendererComponent } from "./custom-cell-loading-renderer/custom-cell-loading-renderer.component";
import { PopoverModule } from "ngx-bootstrap/popover";
import { OverlayscrollbarsModule } from 'overlayscrollbars-ngx';
import { FormsModule } from '@angular/forms';
import { PopoverCellRendererComponent } from './popover/popover-cell-renderer.component';
import { TooltipCellRendererComponent } from './tooltip/tooltip-cell-renderer.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    BsshDataTableComponent,
    BsshColumnSwitcherComponent,
    CustomHeaderComponent,
    SpanCellRendererComponent,
    LinkCellRendererComponent,
    TooltipCellRendererComponent,
    CustomFilterComponent,
    CustomLoadingOverlayComponent,
    CustomCellLoadingRendererComponent,
    PopoverCellRendererComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    PopoverModule,
    LibPopoverModule,
    SelectModule,
    IconButtonModule,
    SkeletonModule,
    ProgressModule,
    PaginationModule,
    AgGridModule.withComponents([
      CustomHeaderComponent,
      SpanCellRendererComponent,
      LinkCellRendererComponent,
      TooltipCellRendererComponent,
      CustomFilterComponent,
      CustomLoadingOverlayComponent,
      CustomCellLoadingRendererComponent,
      PopoverCellRendererComponent
    ]),
    ColumnSwitcherModule,
    RadioCheckboxModule,
    CustomPageSizeControllerModule,
    OverlayscrollbarsModule,
    FormsModule,
    DateRangeModule
  ],
  providers: [
    BsshDataTableMessageService,
    BsshDataTableApiService,
    BsshDataTableServerSideDatasourceService,
  ],
  entryComponents: [CustomHeaderComponent, CustomFilterComponent],
  exports: [BsshDataTableComponent]
})
export class BsshDataTableModule { }
